import React from 'react'

interface SpecialCampaignProps {
  mode?: string
}

const SpecialCampaign: React.FC<SpecialCampaignProps> = ({ mode }) => {
  const target = mode === 'single' ? 'abonnement' : 'datapakke'
  
  return (
    <div className="special-campaign-container">
      <div className="heading">Black Friday-kampanje</div>
      <div className="sub-heading">For valgt {target} gjelder følgende tilbud - kun idag:</div>
      <div className="offer">50% rabatt i 2 måneder</div>
      <div className="fine-print">
        Gjelder prisen på selve abonnementet (ikke tilleggstjenester) ut inneværende måned og de
        to neste. Black Friday-tilbudet kan kun kombineres med ekstra evig GB, ikke
        partnerrabatter som f.eks. OBOS
      </div>
    </div>
  )
}

export default SpecialCampaign
